<template>
  <v-dialog
    :value="show"
    :overlay="false"
    max-width="500px"
    transition="dialog-transition"
    persistent
  >
    <v-card class="py-2 px-5">
      <div class="text-right">
        <v-btn icon @click="$emit('onClose')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <div class=" flex-all-center">
        <icon-warning style="width: 80px; height: 80px" />
      </div>
      <div class="text-center primary--text my-5">
        <template v-if="hasEtaxBill">
          บัญชีสินเชื่อของคุณมีการผูกบัญชีไลน์
          และขอรับใบเสร็จ/ใบกำกับภาษีอิเล็กทรอนิกส์ผ่านบัญชีไลน์
          {{ ` ${lastestLineAccount} ` }} ไว้แล้ว คุณต้องการเปลี่ยนเป็นบัญชีไลน์นี้ใช่หรือไม่?
        </template>
        <template v-else>
          บัญชีสินเชื่อของคุณมีการผูกบัญชีไลน์ชื่อ
          {{ ` ${lastestLineAccount} ` }}
          ไว้แล้ว คุณต้องการเปลี่ยนเป็นบัญชีไลน์นี้ใช่หรือไม่?
        </template>
      </div>
      <div class="text-center red--text my-5">
        หากกด เปลี่ยนบัญชีไลน์ ระบบจะทำการยกเลิกการผูกบัญชีกับไลน์เดิมโดยอัตโนมัติ)
      </div>
      <div style="text-align: center;" class="mt-2 mb-5">
        <v-btn color="#23409a" class="m-1" outlined @click="handleCancel">
          <span>ยกเลิก</span>
        </v-btn>
        <v-btn color="#23409a" class="m-1" @click="handleChangeLineAccount">
          <span class="text-white">เปลี่ยนบัญชีไลน์</span>
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import IconWarning from "./icons/IconWarning.vue";
export default {
  components: { IconWarning },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    hasRegisteredAccount: {
      type: Boolean,
      default: false,
    },
    hasEtaxBill: {
      type: Boolean,
      default: false,
    },
    lastestLineAccount: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleCancel() {
      this.$emit("onClose");
    },
    handleChangeLineAccount() {
      this.$emit("onChangeLineAccount");
    },
  },
};
</script>

<style lang="scss" scoped></style>
